<script>

import config from '../../common/genericPanelConf';
import GenericDetailForm from '../../components/generic/GenericDetailForm.vue';

export default{
    props: ['category', 'name', 'id', 'successMessage'],
    components: { 
        GenericDetailForm
    },
    data(){
        return{
            configuration: null
        }
        // return {
        //     fieldsets: [],
        //     submitted: false,
        //     configuration: {},
        //     fields: [],
        //     disabled: false,
        //     data: {},
        //     fieldsTypes: {},
        // }
    },
    
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            let title = (this.id && this.id != '0') ? `${this.$t(this.configuration.title)} - ${this.$t('Update')} : ${this.id}` : `${this.$t(this.configuration.title)} - ${this.$t('Create')}`;
            this.$store.dispatch('security/setNavbarTitle', title);
        }
    },
    mounted(){
        if(this.successMessage){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
        }
    },
    computed: {
        conf(){
            return config;
        }
    }
}

</script>

<style lang="css" scoped>
</style>


<template>
    <div>
        <GenericDetailForm :configuration="configuration" :category="category" :name="name" :id="id"/>
    </div>
</template>